<template>
  <b-form class="col-md-12 px-0 page-section pt-0" @submit.prevent="onSubmit">
    <b-form-group label="Benefits" label-for="benefits" label-class="form-label">
      <v-select
        id="benefits"
        class="form-control v-select-custom"
        label="text"
        v-model="research.benefits"
        :reduce="(benefit) => benefit.value"
        placeholder="Select benefits"
        :options="benefitOptions"
        multiple
      >
        <template #search="{ attributes, events }">
          <input class="vs__search" v-bind="attributes" v-on="events" />
        </template>
      </v-select>

      <b-form-input
        id="otherBenefits"
        class="mt-1"
        placeholder="Please specify"
        v-model="research.other_benefits"
        required
        v-if="(research.benefits || []).includes('other')"
        :state="!$v.research.other_benefits.required && $v.research.other_benefits.$dirty ? false : null"
      />
      <b-form-invalid-feedback
        :state="!$v.research.other_benefits.required && $v.research.other_benefits.$dirty ? false : null"
        >This field is required.</b-form-invalid-feedback
      >
    </b-form-group>

    <b-form-group
      label="Offers Career Advancement"
      label-for="offers_career_advancement"
      label-class="form-label"
      v-slot="{ ariaDescribedby }"
    >
      <b-form-radio-group
        id="offers_career_advancement"
        v-model="research.offers_career_advancement"
        :options="yesNoOptions"
        :aria-describedby="ariaDescribedby"
      ></b-form-radio-group>
    </b-form-group>

    <div v-if="research.offers_career_advancement === true">
      <b-form-group label="Career Offerings" label-for="career_offerings" label-class="form-label">
        <v-select
          id="career_offerings"
          class="form-control v-select-custom"
          label="name"
          v-model="research.career_offerings"
          :reduce="(career) => career.id"
          placeholder="Select offered careers for career advancement"
          :options="careerOptions"
          multiple
        >
          <template #search="{ attributes, events }">
            <input class="vs__search" v-bind="attributes" v-on="events" />
          </template>
          <template slot="option" slot-scope="option">
            <span>{{ option.name }}</span>
          </template>
        </v-select>

        <b-form-input
          id="other_career_offering"
          class="mt-1"
          placeholder="Please specify"
          v-model="research.other_career_offering"
          required
          v-if="(research.career_offerings || []).includes('other')"
          :state="!$v.research.other_career_offering.required && $v.research.other_career_offering.$dirty ? false : null"
        />
      </b-form-group>

      <b-form-group label="Career Offering Details" label-for="career_offerings_details" label-class="form-label">
        <b-form-textarea
          id="career_offerings_details"
          placeholder="Enter career offering details."
          :rows="5"
          v-model="research.career_offerings_details"
        />
      </b-form-group>
    </div>
  </b-form>
</template>

<script>
import { requiredIf } from 'vuelidate/lib/validators';
import { pick } from 'lodash';
import { JOB_BENEFITS_OPTONS } from '../../../common/constants';

export default {
  name: 'ResearchBenefitsForm',

  props: {
    researchData: { type: Object, required: true },
    careerOptions: { type: Array, default: () => [] },
  },

  data() {
    return {
      research: {
        benefits: [],
        other_benefits: null,
        offers_career_advancement: null,
        career_offerings: [],
        other_career_offering: null,
        career_offerings_details: '',
      },
      benefitOptions: JOB_BENEFITS_OPTONS,
      yesNoOptions: [
        { value: true, text: 'Yes' },
        { value: false, text: 'No' },
      ],
    };
  },

  validations() {
    return {
      research: {
        other_benefits: { required: requiredIf(() => (this.research.benefits || []).includes('other')) },
        other_career_offering: {
          required: requiredIf(() => (this.research.career_offerings || []).includes('other')),
        },
      },
    };
  },

  watch: {
    researchData: {
      handler() {
        this.research = pick(this.researchData, [
          'benefits',
          'other_benefits',
          'offers_career_advancement',
          'career_offerings',
          'other_career_offering',
          'career_offerings_details',
        ]);
      },
      deep: true,
    },
  },

  methods: {
    validateFormData() {
      this.$v.$touch();
      return {
        isValid: !this.$v.$invalid,
        formData: { ...this.research },
      };
    },
  },
};
</script>
